import React from 'react'
import { createPortal } from 'react-dom'
import { Snackbar, Paper, Typography, Divider } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ErrorIcon from '@mui/icons-material/Error'
import WarningIcon from '@mui/icons-material/WarningAmber'
import InfoIcon from '@mui/icons-material/Info'
import CancelIcon from '@mui/icons-material/Cancel';
import { useFullscreenContainer } from 'src/hooks/useFullscreenContainer'

const icons = {
  success: <CheckCircleIcon sx={{ color: 'success.main' }} />,
  error: <ErrorIcon sx={{ color: 'error.main' }} />,
  warning: <WarningIcon sx={{ color: 'warning.main' }} />,
  info: <InfoIcon sx={{ color: 'info.main' }} />
}
const labels = {
  success: "Success",
  error: "Error",
  warning: "Warning",
  info: "Info",
}
const styles = {
  success: { borderLeft: '4px solid #16a34a', backgroundColor: '#ffff' }, // green-600, green-50
  error: { borderLeft: '4px solid #dc2626', backgroundColor: '#ffff' }, // red-600, red-50
  warning: { borderLeft: '4px solid #f59e0b', backgroundColor: '#ffff' }, // yellow-600, yellow-50
  info: { borderLeft: '4px solid #2563eb', backgroundColor: '#ffff' } // blue-600, blue-50
}
const labelColors = {
  success: '#16a34a',
  error: '#dc2626',
  warning: '#f59e0b',
  info: '#2563eb'
}
export default function ShowToast({ id, type, message, open, onClose, duration = 5000 }) {
  const fullscreenContainer = useFullscreenContainer()

  const snackbar = (
    <Snackbar
      open={open}
      onClose={() => onClose(id)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      autoHideDuration={duration}
    >
      <Paper
        elevation={4}
        sx={{
          ...styles[type],
          display: 'flex',
          alignItems: 'center',
          borderRadius: 2,
          px: 2,
          py: 1.5,
          minWidth: 280,
          maxWidth: 400
        }}
      >
        {icons[type]}{' '}
        <Typography
          variant='subtitle2'
          sx={{ ml: 1, fontWeight: 600, color: labelColors[type] || 'rgba(76, 78, 100, 0.87)' }}
        >
          {labels[type]}
        </Typography>
        <Divider orientation='vertical' flexItem sx={{ mx: 1 }} />
        <Typography variant='subtitle2' sx={{ flex: 1, color: 'rgba(76, 78, 100, 0.87 )', mr: 1 }}>
         {message}
        </Typography>
        <CancelIcon sx={{ cursor: 'pointer', color: 'grey', fontSize: '18px' }} onClick={() => onClose(id)} />
        {/* <IconButton size='small' onClick={() => onClose(id)}>
          ✕
        </IconButton> */}
      </Paper>
    </Snackbar>
  )

  if (fullscreenContainer && fullscreenContainer !== document.body) {
    return createPortal(snackbar, fullscreenContainer)
  }

  return snackbar
}
